import { createRoutes } from 'shared/hocs'

import AppDelivery from './appDelivery'
import Layout from './delivery/layout'

export default createRoutes(
  () => [
    {
      path: '/app-testing',
      component: AppDelivery,
    },
  ],
  { switched: true, layout: Layout }
)
